import { Component, Input } from '@angular/core';

@Component({
  selector: 'anms-detail-row',
  templateUrl: './detailRow.component.html',
  styleUrls: ['./detailRow.component.scss'],
   standalone: false
})
export class DetailRowComponent {
  @Input() name!: string;
  @Input() gender!: string;
  @Input() age!: number;
  @Input() yrs!: string;
  constructor() {
  }
  /* #endregion */
}
